import MidiEffect from './MidiEffect.js';
import MidiTrigger from './MidiTrigger.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import Tone from 'tone';

class NoteDisplay extends MidiEffect {
    constructor(track) {
        super('Note Display', track);

        // all it does is keep track of notes that are playing
        this.notes = {};
   }

    removeNote(note, sliceNumber, skip=!this.gated) {
        delete this.notes[note];
    }
    
    output() {
        for (let note in this.notes) {
            this.notes[note]--;
            if (this.notes[note] <= 0) {
                delete this.notes[note];
            }
        }
        for (let trigger of this.triggers) {
            let {transpose, duration} = trigger.stepData;
            this.notes[transpose] = duration*2;
        }
        return this.triggers;
    }

    stop() {
        this.notes = {};
    }

    getCopy(track, ignoreId=true) {
        let fx = new NoteDisplay(track);
        fx.fromJson(this.getJson(), ignoreId);
        return fx;
    }
}

export default NoteDisplay;
